import axios        from 'axios';
import * as actions from '../src/store/actions/index';

const setupInterceptors= (store) => {

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
    return response;
    }, (error) => {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            const { token, refreshToken } = store.getState().checkNRICSessionReducer;
            if(!token){
                return error.response.msg;
            }
            return axios({
                method: 'post',
                url: '/api/accounts/refreshToken',
                data: {
                    'token': token,
                    'refreshToken': refreshToken
                },
                headers: {'Content-Type': 'application/json'}
            })
            .then(({data}) => {
                const response = {
                    token : data.data.token,
                    refreshToken : data.data.refreshToken
                  }
                store.dispatch(actions.onCheckNRICSessionSuccess(response));
                axios.defaults.headers.common['Authorization'] = `Bearer ${data.data.token}`;
                originalRequest.headers['Authorization'] = `Bearer ${data.data.token}`;
                return axios(originalRequest);
            });
        }
        
        return Promise.reject(error);
    });
    
}

export default setupInterceptors;


